query GetSageJournalEntries(
  $page: Int
  $limit: Int
  $filters: [SageJournalEntryFilterConditionInput!]
  $sortBy: String
) {
  sageJournalEntries(
    page: $page
    limit: $limit
    filters: $filters
    sortBy: $sortBy
  ) {
    collection {
      id
      lastSageSyncDate
      accountNumber
      accountTitle
      txnAmount {
        minorUnit
        currency
      }
      amountIssue
      batchDate
      batchNumber
      batchTitle
      batchReference
      caseRecord {
        id
        description
        caseNumber
        transactionDate
      }
      caseAmount {
        minorUnit
        currency
      }
      classId
      className
      currencyIssue
      dateIssue
      description
      entryDate
      exchangeRate
      exchangeRateDate
      fundAccountIssue
      location
      locationName
      numberOfIssues
      sageGiftAccount {
        id
        name
        sageId
      }
      caseLegalEntity
      sageId
      state
      transactionType
      whenCreated
      whenModified
      legalEntityIssue
      caseFundAccount {
        id
        currency
        fund {
          id
          name
          legalEntity {
            id
            name
          }
        }
      }
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
